import slugify from "slugify";
import {
    AUDIO_RESUME,
    AUDIO_PAUSE,
    GAME_COMMAND,
    OPEN_HOME,
    OPEN_LINK,
    OPEN_NEWS_ARTICLE,
    PLAY_SOUND,
    SHOW_BACK_BUTTON,
    BRIDGE_FUNCTION,
} from "supercell-frontend-base/src/constants/types/commands";

import {
    mutateOpenLinkHack,
    OpenLinkPayload,
} from "supercell-frontend-base/src/utils/hack-mutate-open-link";
import { deepLinkSchema } from "inbox-contentful";
import { bridge } from "supercell-frontend-base/src/utils/bridge";

const protocol = deepLinkSchema.squadbusters;

const mutateOpenLink = mutateOpenLinkHack(protocol);

export const commander =
    (
        sendGameCommand: (command: string) => void,
        trackLinkClick: (data: Record<string, string>) => void,
    ) =>
    (navigate: (path: string) => void) =>
    (type: string, payload: OpenLinkPayload) => {
        if (type === OPEN_LINK) ({ type, payload } = mutateOpenLink(payload));

        switch (type) {
            case OPEN_HOME:
                return navigate("/");
            case OPEN_NEWS_ARTICLE:
                return navigate(
                    `/${payload.lang}/news/${payload.id}/${slugify(
                        payload.slug ?? "",
                        {
                            strict: true,
                            lower: true,
                        },
                    )}`,
                );
            case OPEN_LINK:
                trackLinkClick({
                    url: payload.url,
                    id: payload.id || "",
                    label: payload.label || "",
                });

                return sendGameCommand(
                    `${protocol}://OpenWeb?url=${encodeURIComponent(payload.url)}`,
                );
            case PLAY_SOUND:
                return sendGameCommand(
                    `${protocol}://playSound?name=${payload}`,
                );
            case AUDIO_PAUSE:
                return sendGameCommand(`${protocol}://StopMusic`);
            case AUDIO_RESUME:
                return sendGameCommand(`${protocol}://ResumeMusic`);
            case SHOW_BACK_BUTTON:
                return sendGameCommand(
                    `${protocol}://backButton?state=${payload ? "show" : "hide"}`,
                );
            case GAME_COMMAND: {
                const url = `${protocol}://${payload.url}`;
                trackLinkClick({
                    url,
                    id: payload.id || "",
                    label: payload.label || "",
                    additionalInformation: payload.additionalInformation,
                });
                return sendGameCommand(url);
            }
            case BRIDGE_FUNCTION:
                return bridge().then((bridge) => {
                    if (
                        payload.functionName &&
                        payload.functionName in bridge
                    ) {
                        bridge[payload.functionName](
                            ...(payload.functionArgs || []),
                        );
                    }
                });
            default:
                return console.error(`Command not recognized "${type}"`);
        }
    };
